// Automate du coup de pouce au premier lancement (ecran Play).
//
// Pur : pas de React, pas de timers, pas de localStorage. Les delais (800 ms
// d'armement, 8 s par tip, 25 s de drone) et les effets de bord vivent
// dans useGettingStarted, ce qui rend chaque transition testable seule.
//
// Etats :
//   null      inactif, plus rien ne s'affiche
//   tapTonic  tooltip "Start here" sur le chip racine, rien ne joue encore
//   droneTip  un accord sonne, on invite a jouer une note sur la vraie guitare
//   droneWait le tip a disparu, on compte le temps de drone audible
//   tapPlay   tooltip sur Play
//   waitJam   la premiere progression tourne, on attend son arret
//   tapJam    tooltip sur Jam

export const initialState = null;

const ACTIVE_STEPS = ['tapTonic', 'droneTip', 'droneWait', 'tapPlay', 'waitJam', 'tapJam'];

// Etapes ou un tip est affiche et peut donc etre balaye (timer ou interaction).
const DISMISSABLE = {
  droneTip: 'droneWait',
  tapPlay: null,
  tapJam: null
};

// Un tap sur Play depuis une etape de drone saute directement a l'attente du
// Jam : celui qui lance la progression de lui-meme n'a pas besoin qu'on la lui
// montre. Depuis tapTonic c'est autre chose, voir PLAY_TAPPED.
const PLAY_TAPPABLE = ['droneTip', 'droneWait', 'tapPlay'];

export function isActiveStep(state) {
  return ACTIVE_STEPS.includes(state);
}

export function reduce(state, event) {
  const type = typeof event === 'string' ? event : event?.type;

  switch (type) {
    case 'ARM':
      return state === null ? 'tapTonic' : state;

    case 'CHORD_TAPPED':
      return state === 'tapTonic' ? 'droneTip' : state;

    case 'TIP_DISMISSED':
      return Object.prototype.hasOwnProperty.call(DISMISSABLE, state) ? DISMISSABLE[state] : state;

    case 'DRONE_ELAPSED':
      return state === 'droneWait' ? 'tapPlay' : state;

    // Couper le drone dit "j'ai fini avec cet accord" : le bon moment pour
    // proposer les changements, sans attendre les 25 s.
    case 'DRONE_STOPPED':
      return state === 'droneTip' || state === 'droneWait' ? 'tapPlay' : state;

    // Le bouton Play est le seul element blanc plein de l'ecran, c'est lui que
    // l'oeil attrape en premier : un tap avant d'avoir touche un accord n'est
    // pas un raccourci assume, il ne doit pas couter tout le parcours. Les
    // carres sont affiches pendant la progression, la consigne reste valable.
    case 'PLAY_TAPPED':
      if (state === 'tapTonic') return 'droneTip';
      return PLAY_TAPPABLE.includes(state) ? 'waitJam' : state;

    case 'PROGRESSION_STOPPED':
      return state === 'waitJam' ? 'tapJam' : state;

    case 'JAM_TAPPED':
    case 'TIPS_DISABLED':
      return null;

    default:
      return state;
  }
}
